export const PAYPAL_MODAL_TEXT = {
  CONFIRM: 'Payment Confirmation',
  CANCEL: 'Cancel',
  YOU_ARE_ABOUT_TO_PAY: 'You are about to pay the following:',
  TOTAL_CAD: 'TOTAL CAD',
  TOTAL_USD: 'TOTAL USD',
  ENSURE_FUNDS: 'Please ensure that you have sufficient funds before continuing this payment.',
  PAYPAL_DESC: 'The safer, easier way to pay',
};
